import React, { type FunctionComponent, Fragment } from 'react'
import { GeneratedReportsAddContent } from 'legacy/sections/generated-reports/components/add/GeneratedReportsAddContent'
import { useTrackEvent } from 'utils/events/hooks'
import { useGeneratedReportsAddBehaviour } from 'legacy/sections/generated-reports/components/add/utils/generatedReportsAdd.hooks'
import AppHeader from 'legacy/components/AppHeader'
import { GeneratedReportsAddBreadcrumbs } from 'legacy/sections/generated-reports/components/breadcrumbs/components/GeneratedReportsAddBreadcrumbs'
import DocumentTitle from 'legacy/components/DocumentTitle'

export const GeneratedReportsAdd: FunctionComponent = () => {
  useTrackEvent({
    id: 'generated_reports.newReport.viewed',
    description: 'Viewed page to generate a new report',
  })

  const behaviour = useGeneratedReportsAddBehaviour()

  return (
    <Fragment>
      <DocumentTitle titleId="generatedReports.newReport.title" />
      <GeneratedReportsAddContent
        header={<AppHeader title={<GeneratedReportsAddBreadcrumbs />} />}
        {...behaviour}
      />
    </Fragment>
  )
}
